// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import App from "./app/App";
import ChunkErrorBoundary from "./ErrorBoundary";

// INCLUDE ALL THIRD PARTY LIBRARY CSS FILES
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ChunkErrorBoundary>
    <BrowserRouter>
      <SnackbarProvider anchorOrigin={{ horizontal: "right", vertical: "top" }}>
        <App />
      </SnackbarProvider>
    </BrowserRouter>
  </ChunkErrorBoundary>
);


// import ReactDOM from "react-dom/client";
// import { BrowserRouter } from "react-router-dom";
// import { SnackbarProvider } from "notistack";
// import App from "./app/App";

// // INCLUDE ALL THIRD PARTY LIBRARY CSS FILES
// import "perfect-scrollbar/css/perfect-scrollbar.css";
// import "react-big-calendar/lib/css/react-big-calendar.css";
// import "react-big-calendar/lib/addons/dragAndDrop/styles.css";

// // MAIN ROOT ELEMENT
// const root = ReactDOM.createRoot(document.getElementById("root"));

// root.render(
//   <BrowserRouter>
//     <SnackbarProvider anchorOrigin={{ horizontal: "right", vertical: "top" }}>
//       <App />
//     </SnackbarProvider>
//   </BrowserRouter>
// );
